import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { effect, useSignal } from "@preact/signals";
import { nanoid } from "nanoid";
import classNames from "classnames";
import Icon from "../../Icon";
import asArray from "../../../lib/as-array";
import style from "./style.module.scss";
export default function OptionList(props) {
    const { options, multiple = false, onChange, isInput = false } = props;
    const selectedOptions = useSignal(asArray(props.selected));
    effect(() => {
        selectedOptions.value = asArray(props.selected);
    });
    const onOptionChange = (option, checked) => {
        if (multiple) {
            if (checked) {
                selectedOptions.value = [...selectedOptions.value, option];
            }
            else {
                selectedOptions.value = selectedOptions.value.filter((selectedOption) => selectedOption.value !== option.value);
            }
        }
        else {
            selectedOptions.value = [option];
        }
        if (onChange) {
            if (multiple) {
                onChange(selectedOptions.peek());
            }
            else {
                onChange(selectedOptions.peek()[0]);
            }
        }
    };
    return (_jsx("div", { className: classNames({ [style["option-list"]]: !isInput }, { [style["option-list--input"]]: isInput }, "qa-option-list"), children: options.map((option) => (_jsx(Option, { option: option, selected: isSelected(option, selectedOptions.value), multiple: multiple, onChange: onOptionChange }, nanoid()))) }));
}
function isSelected(option, selected) {
    if (Array.isArray(selected)) {
        return selected.some((selectedOption) => option.value === selectedOption.value);
    }
    return option.value === selected.value;
}
export function Option({ option, selected, multiple, onChange }) {
    return (_jsx("div", { role: "menuitem", className: classNames(style["option-list__option"], {
            [style["option-list__option--selected"]]: selected,
        }), children: _jsxs("label", { className: classNames(style["option-list__label"], "qa-option-list__label"), children: [_jsx("input", { className: "visually-hidden", type: multiple ? "checkbox" : "radio", checked: selected, value: option.value, onChange: (event) => onChange && onChange(option, event.target.checked) }), _jsx("div", { className: multiple ? style["option-list__checkbox"] : style["option-list__radio"], children: selected && multiple ? _jsx(Icon, { name: "check" }) : null }), option.label] }) }));
}
